module.exports = "---\nsummary: Defines common messages that are shared between inspection and template records.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.inspect.type.v1/overview.md
// module id = 242
// module chunks = 0